import { ReactNode } from 'react'
import { SuggestedQuestion, SuggestionCard } from '../Cards'
import { Carousel } from '../Carousel'

interface SuggestionCardsCarouselProps {
  allQuestions: SuggestedQuestion[]
  onClick: (text: string) => void
}

const CARD_WIDTH = 164
const CARD_GAP = 10

export const SuggestionCardsCarousel = ({ allQuestions, onClick }: SuggestionCardsCarouselProps) => {
  return (
    <Carousel
      items={allQuestions}
      cardWidth={CARD_WIDTH}
      cardGap={CARD_GAP}
      autoHideWhenFits
      keyExtractor={(_, index) => `suggestion-${index}`}
      renderItem={(question) => (
        <SuggestionCard
          question={question}
          onClick={onClick}
          key={question.question}
        />
      )}
    />
  )
}
